import modalWindows from "./ModalWindowsModule";
import editingSideform from "./EditingSideformModule";
import products from "./ProductsModule";
import components from "./ComponentsModule";
import pages from "./PagesModule";
import elements from "./ElementsModule";
import globalConfig from "./GlobalConfigModule";
import common from "./CommonApiModule";
import sections from "./SectionsModule";
import topbar from "./TopbarModule";
import footer from "./FooterModule";
import user from "./UserModule";
import blog from "./BlogModule";
import blogCatalogue from "./BlogCatalogueModule";
import UiInteractions from "./UIInteractionsModule";
import siteTemplate from "./SiteTemplateModule";
import authoringSettings from "./AuthoringSettingsModule";

export default {
    authoringSettings,
    blog,
    blogCatalogue,
    common,
    components,
    editingSideform,
    elements,
    footer,
    globalConfig,
    modalWindows,
    pages,
    products,
    sections,
    siteTemplate,
    topbar,
    user,
    UiInteractions,
};
